export const DEFAULT_SUGGESTIONS = ['SIMOA', 'HD-X', 'NfL', 'Tau'];
